import { useCallback } from 'react';

import { useAppDispatch } from 'shared/lib';

import { runAfterCheckFormReadyThunk } from '../../../entities/creditForm';

import { fetchOffersThunk } from './fetchOffersThunk';

export const useFetchOffersData = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    (enableMpl = false): Promise<{ isAvailableMpl?: boolean }> => {
      return new Promise((resolve) => {
        dispatch(
          runAfterCheckFormReadyThunk(async (isReady) => {
            if (isReady) {
              const result = await dispatch(fetchOffersThunk({ isUseMpl: enableMpl })).unwrap();
              resolve(result);
              return;
            }
            resolve({});
          }),
        );
      });
    },
    [dispatch],
  );
};
